module.exports = __webpack_public_path__ + "static/assets/b4d36363b436d6ed874beef5eb11ee0f.png";